import {theme} from './theme'

export const createMediaQuery = (minWidth: string) =>
  `@media screen and (min-width: ${minWidth})`

export const small = createMediaQuery(theme.breakpoints[0])
export const medium = createMediaQuery(theme.breakpoints[1])
export const large = createMediaQuery(theme.breakpoints[2])
